import { mdiPassport, mdiBriefcaseOutline, mdiFileDocumentMultipleOutline } from '@mdi/js'
import { PRIVATE } from '@/plugins/acl/const'

export default [
  {
    subheader: 'immigration',
    resource: PRIVATE.IMMIGRATION.MENU_HEADER,
    action: 'read',
  },
  {
    title: 'legalizationOfStay',
    icon: mdiPassport,
    to: 'immigration-legalization-of-stay',
    resource: PRIVATE.IMMIGRATION.LEGALIZATION_OF_STAY,
    action: 'read',
  },
  {
    title: 'legalizationOfWork',
    icon: mdiBriefcaseOutline,
    to: 'immigration-legalization-of-work',
    resource: PRIVATE.IMMIGRATION.LEGALIZATION_OF_WORK,
    action: 'read',
  },
  {
    title: 'immigrationProcesses',
    icon: mdiFileDocumentMultipleOutline,
    to: 'immigration-processes',
    resource: PRIVATE.IMMIGRATION.PROCESSES,
    action: 'read',
  },
]
